import React from 'react';
// eslint-disable-next-line
import { QRCodeCanvas } from 'qrcode.react';

const QRCodeComponent = ({ url }) => (
    <div>
      <QRCodeCanvas value={url} size={160} level="H" />
    </div>
  );
export default QRCodeComponent;
